import { Scene, Color, Fog, HemisphereLight, DirectionalLight } from 'three';
import { TerrainType } from '../game/StageLoader';

export class Sky {
  constructor(scene: Scene, terrain: TerrainType = 'desert') {
    if (terrain === 'ocean') {
      this.buildOceanSky(scene);
    } else if (terrain === 'mountain') {
      this.buildMountainSky(scene);
    } else {
      this.buildDesertSky(scene);
    }
  }

  private buildDesertSky(scene: Scene): void {
    scene.background = new Color(0x6a9fd8);
    scene.fog = new Fog(0xd4b87a, 4000, 18000);

    const hemi = new HemisphereLight(0x9ab8e8, 0xc4a265, 0.9);
    scene.add(hemi);

    const sun = new DirectionalLight(0xfff8e0, 1.4);
    sun.position.set(800, 1200, 400);
    sun.castShadow = true;
    sun.shadow.mapSize.width = 2048;
    sun.shadow.mapSize.height = 2048;
    sun.shadow.camera.near = 0.5;
    sun.shadow.camera.far = 5000;
    sun.shadow.camera.left = -2000;
    sun.shadow.camera.right = 2000;
    sun.shadow.camera.top = 2000;
    sun.shadow.camera.bottom = -2000;
    scene.add(sun);
  }

  private buildMountainSky(scene: Scene): void {
    scene.background = new Color(0x7a8a98);
    scene.fog = new Fog(0x8a9aa8, 3000, 16000);

    const hemi = new HemisphereLight(0x8a9aaa, 0x4a6a3a, 0.85);
    scene.add(hemi);

    const sun = new DirectionalLight(0xe8e0d8, 1.0);
    sun.position.set(400, 1000, 600);
    sun.castShadow = true;
    sun.shadow.mapSize.width = 2048;
    sun.shadow.mapSize.height = 2048;
    sun.shadow.camera.near = 0.5;
    sun.shadow.camera.far = 5000;
    sun.shadow.camera.left = -2000;
    sun.shadow.camera.right = 2000;
    sun.shadow.camera.top = 2000;
    sun.shadow.camera.bottom = -2000;
    scene.add(sun);
  }

  private buildOceanSky(scene: Scene): void {
    scene.background = new Color(0x87ceeb);
    scene.fog = new Fog(0x9ac8e0, 5000, 22000);

    const hemi = new HemisphereLight(0x87ceeb, 0x336688, 0.8);
    scene.add(hemi);

    const sun = new DirectionalLight(0xffffff, 1.2);
    sun.position.set(600, 1400, 800);
    sun.castShadow = true;
    sun.shadow.mapSize.width = 2048;
    sun.shadow.mapSize.height = 2048;
    sun.shadow.camera.near = 0.5;
    sun.shadow.camera.far = 5000;
    sun.shadow.camera.left = -2000;
    sun.shadow.camera.right = 2000;
    sun.shadow.camera.top = 2000;
    sun.shadow.camera.bottom = -2000;
    scene.add(sun);
  }
}
